import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CircleFilledIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <rect width="24" height="24" fill="currentColor" rx="12"/>
        </svg>
    </IconWrapper>
));
